module.exports = __webpack_public_path__ + "img/Admin Logo 2.0.73b31bd9.png";